/* eslint-disable no-param-reassign,no-prototype-builtins,no-underscore-dangle,@typescript-eslint/no-unused-vars */

xplenty.controller('ComponentEditorFacebookSourceController', [
  '$scope',
  '$rootScope',
  '$timeout',
  '$controller',

  function ($scope, $rootScope, $timeout, $controller) {
    angular.extend(this, $controller('ConnectionStep', { $scope }));
    $scope.componentFormStep = $scope.$parent.createStep(
      'Source properties',
      'Define your Facebook Ads Insights report properties',
      $scope.component.editorDirective,
    );
    $scope.schemaImporterStep = $scope.$parent.createStep(
      'Schema',
      'Select input fields',
      '<schema-importer component="component" has-error="schemaImporterStep.error" />',
    );

    const getValueName = function (key, value) {
      const $label = angular.element(`[for="${key}"]`);
      const $next = $label.next();
      if ($next.is('.btn-group-select')) {
        value = $next.find(`[value="${value}"]`).text();
      } else if ($next.is('select#ad_accounts')) {
        value = '';
        const $options = $next.find(':selected');
        if ($options.length > 3) {
          value = `${$options.length} selected acounts`;
        } else {
          $options.each(function (index) {
            value += $(this).text() + (index === $options.length - 1 ? '' : ', ');
          });
        }
      } else if ($next.is('select')) {
        value = $next.find(':selected').text();
      }
      return value;
    };

    $scope.componentFormStep.validate = function () {
      const _this = this;
      const form = $scope.componentForm || $scope.form.componentForm;
      this.valid = form && form.$valid;
      this.error = (function () {
        let error = false;
        // var formControls = [];
        if (form) {
          _.each(form, function (value, key) {
            if (typeof value === 'object' && value.hasOwnProperty('$modelValue')) {
              // formControls.push(value)
              if (value.$invalid && value.$dirty) {
                error = true;
              }
            }
          });
        }
        return error;
      })();

      const tags = [];
      const addTag = function (key, label) {
        if ($scope.component[key] && $scope.component[key].length > 0) {
          tags.push({ name: `${_.escape(label)}: <b>${_.escape(getValueName(key, $scope.component[key]))}</b>` });
        }
      };
      addTag('api_version', 'API Version');
      addTag('ad_accounts', 'Accounts');
      addTag('level', 'Level');
      addTag('report_date_range_type', 'Date range');
      addTag('action_report_time', 'Action report time');
      addTag('time_increment', 'Time breakdown');
      _this.tags = tags;

      return this.valid;
    };

    $scope.$on('facebook.accounts.loaded', function () {
      $scope.componentFormStep.validate();
    });

    $scope.schemaImporterStep.validate = function () {
      this.valid = $scope.component.schema.fields.length > 0;

      if (this.valid) {
        this.tags = _.map($scope.component.schema.fields, function (field) {
          return {
            name: _.escape(field.name),
          };
        });
      } else {
        this.tags = [];
      }

      return this.valid;
    };

    const isComponentValid = function () {
      $scope.connectionStep.validate();
      $scope.componentFormStep.validate();
      $scope.schemaImporterStep.validate();
    };

    $scope.$watch('component', isComponentValid, true);
  },
]);
